// extracted by mini-css-extract-plugin
export default {"tools":"product-strategy-module--tools--nN4YX","parallax":"product-strategy-module--parallax--NhMnw"};